<div class="dialog-wrapper">
  <div class="c-dialog-content">
    @if (dialogData.approvalQuestion) {
    <p class="c-dialog-text mb-unset mt-unset">{{dialogData.approvalQuestion}}</p>
    }
  </div>
  <div class="c-dialog-actions">
    <button (click)="closeDialog()" pButton pRipple
      class="c-button light cancel">{{dialogData.cancelBtnText || 'Cancel'}}</button>
    <button pButton pRipple class="c-button primary save">{{dialogData.approveBtnText || 'Approve'}}</button>
  </div>
</div>
